export default __webpack_public_path__ + "static/media/own-land.f9554326.png";